import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

export default function viewPointIcon(props:any) {

    return (

            <SvgIcon {...props} viewBox="0 0 18 18">
            <path d="M9 0C8.55011 0 8.10023 0.170979 7.73132 0.530934L0.533117 7.73003C-0.177706 8.43195 -0.177706 9.5658 0.533117 10.2677L7.73132 17.4668C8.43314 18.1777 9.56686 18.1777 10.2687 17.4668L17.4669 10.2677C18.1777 9.5658 18.1777 8.43195 17.4669 7.73003L10.2687 0.530934C9.89978 0.170979 9.44989 0 9 0ZM9 1.79978L16.1982 8.99887L9 16.198L1.8018 8.99887L9 1.79978Z" fill="#E7EFF8"/>
            </SvgIcon>
    )
}
